export const classes = {
  dialog: 'w-[90vw] max-w-[432px] px-6 pb-3 pt-6',
  header: 'flex items-start gap-3',
  iconTile:
    'place-center size-10 flex-none rounded-xl bg-grad text-white shadow-[0_10px_22px_-7px_rgba(241,90,43,0.42)] dark:bg-grad-dark',
  titles: 'min-w-0 flex-1',
  title:
    'text-[17px] font-extrabold tracking-[-0.01em] text-taupe-3 dark:text-mauve-1',
  subtitle:
    'mt-1.5 text-[13px] font-normal leading-[1.55] text-taupe-2 dark:text-mauve-2',
  closeButton: 'text-taupe-1 dark:text-mauve-3',
  planCard:
    'mt-[22px] rounded-2xl border border-black/10 bg-white/[0.82] px-5 py-[18px] shadow-aurora-card dark:border-white/10 dark:bg-[#332e43]/[0.84]',
  planRow: 'flex items-baseline gap-2',
  planName: 'text-xl font-extrabold text-taupe-3 dark:text-mauve-1',
  aiMark:
    'text-[0.5rem] font-semibold text-brand-accent dark:text-brand-accent-dark',
  planSpacer: 'flex-1',
  planPrice: 'text-[19px] font-extrabold text-taupe-3 dark:text-mauve-1',
  planPriceUnit: 'text-xs text-taupe-1 dark:text-mauve-3',
  features: 'mt-4 flex flex-col gap-2.5',
  feature: 'place-start gap-2.5 text-[13px] text-taupe-3 dark:text-mauve-1',
  checkIcon: 'flex-none text-[#16a34a]',
  startButton:
    'mt-[22px] w-full rounded-[13px] py-[13px] text-sm shadow-[0_12px_26px_-9px_rgba(241,90,43,0.42)]',
  dismissButton: 'mt-2 w-full rounded-[13px] py-2.5 text-[13px]',
};
